import { useState, useEffect } from "react";
import getclassNames from "../../../utils/getClassNames";
import Button from "../../UI/Button";
import ReportStepProps from "./ReportStepProps";
import { format, isMatch, parse } from "date-fns";
import IconButton from "../../UI/IconButton";
import { ACTIVE_DATE_RANGE } from "../../../constants/reportStep";
import Input from "../../UI/Input";
import { isValidISODate } from "../../../utils/dateHelpers";

const ACTIVE_FROM_DATE = 'active_from_date';
const ACTIVE_TO_DATE = 'active_to_date';

const ActiveDateRange = (props: ReportStepProps) => {
    const [localFrom, setLocalFrom] = useState(props.values.find(v => v.name === ACTIVE_FROM_DATE)?.value || '');
    const [localTo, setLocalTo] = useState(props.values.find(v => v.name === ACTIVE_TO_DATE)?.value || '');

    useEffect(() => {
        setLocalFrom(props.values.find(v => v.name === ACTIVE_FROM_DATE)?.value || '');
        setLocalTo(props.values.find(v => v.name === ACTIVE_TO_DATE)?.value || '');
    }, [props.values]);

    const handleToggleExpanded = () => {
        props.onExpand(ACTIVE_DATE_RANGE, !props.expanded);
    };

    const handleOnChange = (fieldName: string, value: string) => {
        if (fieldName === ACTIVE_FROM_DATE) setLocalFrom(value);
        if (fieldName === ACTIVE_TO_DATE) setLocalTo(value);

        const otherValues = props.values.filter(v => v.name !== fieldName);
        props.onChange({
            step: ACTIVE_DATE_RANGE,
            values: [
                ...otherValues,
                { name: fieldName, value }
            ]
        });
    };

    const handleOnNext = () => {
        props.onNext(ACTIVE_DATE_RANGE);
    };

    const formattedFromDate = !localFrom || !isMatch(localFrom, 'yyyy-MM-dd') ?
        '' : 
        format(parse(localFrom, 'yyyy-MM-dd', new Date()), 'MM/dd/yyyy');
    const formattedToDate = !localTo || !isMatch(localTo, 'yyyy-MM-dd') ? 
        '' :
        format(parse(localTo, 'yyyy-MM-dd', new Date()), 'MM/dd/yyyy');
    const hasInvalidDate = (localFrom !== '' && !isValidISODate(localFrom)) || (localTo !== '' && !isValidISODate(localTo));
        
    return (
        <div className={getclassNames('report-step', props.expanded ? 'expanded' : '')}>
            <div className="report-step-header">
                <div className="row justify-content-between align-items-center">
                    <div className="column-auto">
                        <h3>Select a date range{formattedFromDate && formattedToDate ? ` - ${formattedFromDate} to ${formattedToDate}` : ''}</h3>
                    </div>
                    <div className="column-1">
                        <IconButton id="toggle-report-perspective-expansion"
                            className="small flat"
                            disabled={props.disabled}
                            icon={props.expanded ? (<i className="ri-arrow-up-s-line"></i>) : (<i className="ri-arrow-down-s-line"></i>)}
                            onClick={handleToggleExpanded} />
                    </div>
                </div>
            </div>
            <div className="report-step-body">
                <div className="row margin-bottom-3">
                    <div className="column">
                        <div className="row">
                            <div className="column">
                                <Input id="date-range-from"
                                    type="date"
                                    label="Active From Date"
                                    value={localFrom} // Use local state
                                    onChange={(v) => handleOnChange(ACTIVE_FROM_DATE, v)} />
                            </div>
                            <div className="column">
                                <Input id="date-range-to"
                                    type="date"
                                    label="Active To Date"
                                    value={localTo} // Use local state
                                    onChange={(v) => handleOnChange(ACTIVE_TO_DATE, v)} />
                            </div>
                        </div>
                    </div>
                </div>
                {hasInvalidDate && <p className="text-danger">Enter valid dates in YYYY-MM-DD format with a four-digit year.</p>}
                <div className="row justify-content-end margin-bottom-3">
                    <div className="column-auto">
                        <Button id="report-type-next"
                            text="Next"
                            icon={<i className="ri-arrow-right-s-line"></i>}
                            iconLocation="end"
                            className="secondary"
                            disabled={!localFrom || !localTo || hasInvalidDate || props.disabled}
                            onClick={handleOnNext} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ActiveDateRange;
